import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Act } from 'src/logic/act';
import { Actions } from 'src/logic/enum/actions';
import { Model } from 'src/logic/model';
import { text } from 'src/services/text.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

constructor(private injector: Injector){}

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
return next.handle(request)
  .pipe(
    catchError(error  => {
      console.log('interceptor', error);
      let errMsg = text.of('Server error');
      if (error instanceof HttpErrorResponse) {
       //unauthenticated
       console.log('intercept status', error.status);
       if(error.status === 400 || error.status === 401){
         const act = this.injector.get(Act);
         act.do(Actions.unauthenticatedRequest);
         return throwError('401');
       }

       // Client Side Error
       if (error.error instanceof ErrorEvent) {
         errMsg += `Error: ${error.error.message}`;
       }
       else {  // Server Side Error
         errMsg += `Error Code: ${error.status},  Message: ${error.message}`;
       }
       return throwError(errMsg);
      }
      console.log('http error',errMsg);
      alert(errMsg);
      return throwError(errMsg);
     })
  );
}
}